import { render, staticRenderFns } from "./KolInfo.vue?vue&type=template&id=cf35a8f8&scoped=true&"
import script from "./KolInfo.vue?vue&type=script&lang=js&"
export * from "./KolInfo.vue?vue&type=script&lang=js&"
import style0 from "./KolInfo.vue?vue&type=style&index=0&id=cf35a8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf35a8f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf35a8f8')) {
      api.createRecord('cf35a8f8', component.options)
    } else {
      api.reload('cf35a8f8', component.options)
    }
    module.hot.accept("./KolInfo.vue?vue&type=template&id=cf35a8f8&scoped=true&", function () {
      api.rerender('cf35a8f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/follow-up/children/components/KolInfo.vue"
export default component.exports